import { render, staticRenderFns } from "./system_language_selector.vue?vue&type=template&id=a282055a&scoped=true"
import script from "./system_language_selector.vue?vue&type=script&lang=js"
export * from "./system_language_selector.vue?vue&type=script&lang=js"
import style0 from "./system_language_selector.vue?vue&type=style&index=0&id=a282055a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282055a",
  null
  
)

export default component.exports